<template>
    <div class="sa-card sa-fm sa-card-noshadow sa-card2-bg" :class="mWebView ? 'sa-mweb-view' : ''">
        <span class="sa-f-size10">Family Members</span>
        <div class="sa-members sa-mt10">
            <template v-if="!familyList.members.length">
                <h6 class="sa-text-center sa-f-size12">
                    <img src="../../assets/img/no-member.svg" alt="" class="sa-avtar-xs sa-verticle-midle">
                     This user has not yet added any family member
                </h6>
            </template>
            <template v-else>
                <ul class="sa-family-members">
                    <li v-for="(familyMember, index) in membersList" :key="familyMember.id" class="sa-memb-pro" @click="$router.push(`/family-members?suid=${familyList.suid}`)">
                        <span class="sa-badge sa-cursor" :style="findRandomInRange(index)">{{ familyMember.sn }}</span>
                        <p>{{ familyMember.name }}</p>
                    </li>
                    <template v-if="mWebView">
                        <li class="sa-badge-count" v-if="familyList.members.length > 4"
                            @click="$router.push(`/family-members?suid=${familyList.suid}`)">
                            <span>+{{ familyList.members.length - 4 }}</span>
                        </li>
                    </template>
                </ul>
                <!-- <span class="sa-badge-member" @click="$router.push(`/family-members?suid=${familyList.suid}`)">
                    <i class="icon-arrow-right"></i>
                </span> -->
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: ['familyList'],
    data() {
        return {
            mWebView: false,
            membersList: [],
            arrayOfColours: [
                { 'color': '#007AAF', 'bg': '#A6E4FF' },
                { 'color': '#AF5400', 'bg': '#FFD1A6' },
                { 'color': '#A4004E', 'bg': '#FFA6D0' },
                { 'color': '#558E00', 'bg': '#C3E393' },
                { 'color': '#0059A4', 'bg': '#B8D7F1' }
            ],
        }
    },
    methods: {
        findRandomInRange(index) {
            let randomColor = index < this.arrayOfColours.length ? index : index % this.arrayOfColours.length
            return {
                color: this.arrayOfColours[randomColor].color,
                'background-color': this.arrayOfColours[randomColor].bg
            }
        },
    },
    mounted() {
        let familyMemberList = this.familyList.members
        if(typeof window != 'undefined' && window.innerWidth <= 768 && this.$route.path === '/dashboard'){
            this.mWebView = true
            this.membersList = familyMemberList.slice(0,4)
        }else{
            this.mWebView = false
            this.membersList = familyMemberList
        }
    },
}
</script>

<style scoped>
.sa-card2-bg {
    background-color: #E2F7FF;
}

.sa-family-members {
    display: flex;
    line-height: 30px;
    margin-top: 10px;overflow: hidden;overflow-x: auto;
}

.sa-family-members li {
    position: relative;
    width: 30px;
    margin-right: 15px;
    height: 52px;
}

.sa-family-members li p {
    text-overflow: ellipsis;
    margin-top: 25px;
    font-size: 10px;
    overflow: hidden;
    text-align: center;
}

.sa-family-members .sa-badge {
    left: 0;
    top: 0;
}

.sa-patient-list span {
    color: #0080FF;
    cursor: pointer;
    top: 48px;
    right: 5px;
    font-size: 10px;
}

::-webkit-scrollbar-thumb {
    background-color: #0080FF;
}

::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    cursor: pointer;
}

.sa-patient-user .sa-badge-member {
    width: 25px;
    height: 25px;
    border-radius: 100%;
    border: 1px solid #0080FF;
    text-align: center;
    color: #0080FF;
    cursor: pointer;
}

.sa-patient-user .sa-badge-member {
    position: absolute;
    right: 20px;
    top: 50%;
    line-height: 25px;
    text-align: center;
}

.sa-user-list .sa-badge-member {
    position: absolute;
    display: none;
}

.sa-family-members .sa-badge-count {
    width: 30px;
    height: 30px;
    border: 1px solid var(--sa-info);
    border-radius: 50%;
    color: var(--sa-info);
    display: flex;
    align-items: center;
    font-size: 11px;
    justify-content: center;
    cursor: pointer;
}.sa-mweb-view .sa-family-members {
    overflow: hidden;
}
</style>
